module.exports = __webpack_public_path__ + "img/cases-brand-maxam-lazyload-11.6bca89a5.jpg";